import styles from './Secure.module.css';

import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import img2 from '../../assets/imgs/img12.png';



export const Secure = () => {
  return (
    <div>
        <Container className={`${styles.section}`}>
            <Row className={`${styles.row}`}>
            <Col lg={6} sm={12} xs={12} md={6}>
           <div className={`${styles.imgcol}`}>
            <img src={img2} alt='service sectionimage' className={`${styles.img}`} />
            </div>
            </Col>

            <Col lg={6} sm={12} xs={12} md={6}>
                <div>
                    <h2 className={`${styles.free}`}>Secured Payments</h2>
                    <p className={`${styles.desc}`}>Your payments are secured; payments isn’t released
                        until you approve your work, plus you know what
                        you paying upfront..</p>
                </div>
            </Col>
            </Row>
        </Container>
    </div>
  )
}
